import CityServiceTemplate from "@/components/CityServiceTemplate";
import sanAntonioHero from "@/assets/cities/san-antonio-hero.jpg";

const CarServiceSanAntonio = () => {
  return (
    <CityServiceTemplate
      cityName="San Antonio"
      cityDescription="Premier black car service throughout San Antonio, TX. From downtown to Stone Oak, Alamo Heights to the Medical Center, Rick's provides luxury transportation for all your needs."
      metaDescription="Professional black car service in San Antonio, TX. Airport transfers, corporate travel, special events, and hourly chauffeur service. Book Rick's today."
      canonicalPath="/san-antonio-car-service"
      heroImage={sanAntonioHero}
      additionalContent="As San Antonio's premier black car service, Rick's serves all neighborhoods and districts including downtown, Stone Oak, Alamo Heights, the Medical Center, and beyond. Whether you need corporate transportation, airport service to SAT, or luxury rides for special occasions, our professional chauffeurs deliver exceptional service with every trip."
      coordinates={{
        latitude: 29.4241,
        longitude: -98.4936
      }}
      serviceRadius="30 miles"
      cityReviews={[
        {
          author: "Marcus Rivera",
          rating: 5,
          date: "2024-11-15",
          text: "Rick's service is outstanding for San Antonio business travel. Always punctual, professional, and the Audi Q7 is immaculate. My go-to for downtown meetings and SAT airport runs."
        },
        {
          author: "Lisa Chang",
          rating: 5,
          date: "2024-10-28",
          text: "Used Rick's for our wedding in Stone Oak. The service was flawless from start to finish. Rick made sure we arrived on time and in style. Highly recommend for special events in San Antonio!"
        },
        {
          author: "James Patterson",
          rating: 5,
          date: "2024-12-03",
          text: "Best car service in San Antonio hands down. Rick knows the city like the back of his hand - from Alamo Heights to Medical Center, he always finds the fastest route. Five stars!"
        }
      ]}
    />
  );
};

export default CarServiceSanAntonio;
